<template>
    <a
        aria-selected="false"
        class="w-full max-w-full flex bg-white   select-none rounded-xl py-2 px-2 hover:bg-neutral-100 z-30"
        href="#" tabindex="-1" @click.stop="goto(result.href)">
        <div class="flex w-7 h-7 flex-none rounded-full">
            <img :src="result.image" class="w-7 h-7 object-contain rounded-full">
        </div>
        <div class="ml-4 flex-auto max-w-full min-w-0 ">

            <div class="flex justify-between items-center">
                <div class="flex items-center text-sm font-medium text-gray-700">
                    <div class="pr-1 text-zinc-800 text-sm font-medium leading-tight">
                        {{ result.name }}
                    </div>

                    <CheckBadgeIcon
                        v-if="result.has_owner"
                        class="w-5 h-5 text-zinc-800"/>
                </div>


                <div class="flex items-center">
                    <svg
class="mr-1" fill="none" height="13" viewBox="0 0 14 13" width="14"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7 0L8.97496 4.2817L13.6574 4.83688L10.1955 8.0383L11.1145 12.6631L7 10.36L2.8855 12.6631L3.80445 8.0383L0.342604 4.83688L5.02504 4.2817L7 0Z"
                            fill="#333333"/>
                    </svg>

                    <span class="text-zinc-800 text-sm font-medium leading-normal tracking-wide mr-1">{{
                            result.star_rating
                        }}</span>


                    <span class="mr-1 text-gray-400 text-sm font-medium leading-normal tracking-wide">({{
                            result.review_count
                        }} reviews)</span>


                    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path
d="M10.75 8.75L14.25 12L10.75 15.25" stroke="#333333" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="1.5"/>
                    </svg>


                </div>
            </div>


        </div>
    </a>
</template>
<script>
import {router} from '@inertiajs/vue3';
import {CheckBadgeIcon} from '@heroicons/vue/24/solid/esm/index.js';

export default {
    components: {
        CheckBadgeIcon
    },

    props: {
        result: {
            type: Object,
            required: true,
        }
    },

    methods: {
        goto(url) {
            router.visit(url);
        }
    }
};
</script>
